<div class="p-4 w-full flex flex-col justify-center" *ngIf="members">
    <app-project-members id="members" class="w-full" [mode]="mode" [model]="members" [(form)]="form" [master_form]="master_form" proofreading></app-project-members>
    <div class="p-4 w-full flex justify-end">
        <button mat-flat-button class="bg-tw-primary text-tw-lightgrey w-40" (click)="onSave()" [disabled]="form.invalid"> {{ 'SAVE' | translate }} </button>
    </div>
</div>